import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';
import ClientService from '../../../services/ClientService';
import SectionHeader from '../../common/SectionHeader';
import Section from '../../common/Section';
import SummaryField from './SummaryField';
import ClientRequirements from './ClientRequirements';
import TaskSectionList from '../Tasks/TaskSectionList';
import CancelButton from '../../form/controls/CancelButton';
import ContactList from '../ProjectContacts/ContactList';
import withProjectContext from '../withProjectContext';

class ProjectSummary extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      requirements: {},
      taskSections: [],
      tasks: []
    }
  }

  componentDidMount() {

    if (this.props.project) {

      const { company, contact } = this.props.project.attributes;

      ClientService
        .getByCompanyAndContact(company.id, contact.id)
        .then(requirements => this.setState({ requirements }))
        .catch(error => console.log(error));
    }
  }

  render() {

    const project = { ...this.props.project.attributes };

    return (
      <Fragment>
        <SectionHeader title="Schedule" />
        <Section className="edit-page summary">
          <form action="">
            <div className="col">
              <fieldset>
                <h2>Project Summary</h2>
                <SummaryField title="Project number" value={project.projectNumber} />
                <SummaryField title="Project name" value={project.projectName} />
                <SummaryField title="Complexity" value={project.complexity} />
              </fieldset>
              <fieldset>
                <h2>Coordinator</h2>
                <SummaryField title="Company name" value={project.company.name} />
                <SummaryField title="Coordinator name" value={project.contact.name} />
                <SummaryField title="Coordinator email" value={project.contact.email} />
                <SummaryField title="Coordinator phone" value={project.contact.phone} />
              </fieldset>
              {(project.projectType == 0 && project.intervu) &&
                (<Fragment>
                  <fieldset>
                    <h2>End Client</h2>
                    <SummaryField title="End client company name" value={project.intervu.clientCompany.name} />
                    <SummaryField title="End client name" value={project.intervu.clientContact.name} />
                    <SummaryField title="End client email" value={project.intervu.clientContact.email} />
                    <SummaryField title="End client phone" value={project.intervu.clientContact.phone} />
                  </fieldset>
                </Fragment>)}
              <fieldset>
                <h2>Contacts</h2>
                <div className="row">
                  <label className="title"></label>
                  <div className="right dates">
                    <ContactList projectId={this.props.project.id} />
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <h2>Tasks</h2>
                <div className="row">
                  <label className="title"></label>
                  <div className="right dates">
                    <TaskSectionList
                      projectId={this.props.project.id}
                      projectType={project.projectType}
                      allowSchedule
                      allowComplete />
                  </div>
                </div>
              </fieldset>
            </div>
            <div className="col">
              <fieldset>
                <h2>Client Requirements</h2>
                <ClientRequirements client={this.state.requirements} />
              </fieldset>
            </div>
            <div className="col">
              <fieldset className="buttons-container">
                <CancelButton title="Close" path={this.props.returnPath} />
              </fieldset>
            </div>
          </form>
        </Section>
      </Fragment>
    );
  }
}

ProjectSummary.propTypes = {
  project: PropTypes.object.isRequired
};

export default withProjectContext(ProjectSummary);



// WEBPACK FOOTER //
// ./src/components/projects/ProjectSummary/index.js